import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function showEditDialog(params) {
    showFormDialog({
        title: params.t('editDialog.title'),
        config: {
            type: 'form',
            children: [
                {
                    type: 'form.text',
                    key: 'name',
                    label: 'Name',
                    validate: { required: true },
                },
                {
                    type: 'form.text',
                    key: 'summary',
                    label: 'Summary',
                    multiline: true,
                    rows: 4,
                },
            ],
        },
        data: {
            name: params.file.columns.name,
            summary: params.file.columns.summary,
        },
        onSubmit: (data) => params.storage
            .post({ action: 'partial-update', id: params.file.id, data: data })
            .then((response) => {
            const fileEntityType = params.fileEntityType;
            showAlertSnackbar({
                horizontalPosition: 'center',
                type: 'success',
                verticalPosition: 'bottom',
                autoHideDuration: 2000,
                message: params.t('editDialog.editSnackbar', { fileEntityType }),
            });
            params.onSuccess(response, data.name, data.summary);
        })
            .catch(handleErrorSnackbar),
    });
}
